import React, { useEffect, useMemo, useState } from "react";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isSafari = useMemo(
    () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    []
  );
  const isIOS = useMemo(() => /iPad|iPhone|iPod/.test(navigator.userAgent), []);

  const [viewportHeight, setViewportHeight] = useState(
    window.visualViewport?.height || window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.visualViewport?.height || window.innerHeight);
    };

    window.visualViewport?.addEventListener("resize", handleResize);
    // Run once in case viewportHeight changes immediately after mount
    handleResize();

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {isSafari || isIOS ? (
        <>{children}</>
      ) : (
        <div
          className="bg-white flex flex-col"
          style={{ height: viewportHeight }}
        >
          {children}
        </div>
      )}
    </>
  );
};

export default Layout;
